<div class="device-detail">
  <div class="modal-main px-2">
    <div class="header">
      <ng-container *ngIf="parentType === CONSTANTS.UNIT">
        <div class="d-flex justify-content-between my-3 pb-2">
          <h1 class="modal-title m-auto pl-4 text-center">
            <app-with-tooltip [showHelpCursor]="true">
              {{ formInstance?.deviceName.value }}
            </app-with-tooltip>
            {{ "SETTINGS" | translate }}
          </h1>
          <img
            src="/assets/svg/ico-hamburger-close.svg"
            class="cross-button pointer-cursor pr-3"
            (click)="closeDialog()"
          />
        </div>
      </ng-container>

      <ng-container *ngIf="parentType === CONSTANTS.ACCESSPOINT">
        <div class="d-flex justify-content-between my-4 pb-2">
          <h1 class="modal-title m-auto pl-4 text-center">
            <app-with-tooltip [showHelpCursor]="true">
              {{ formInstance?.deviceName.value }}
            </app-with-tooltip>
            {{ "SETTINGS" | translate }}
          </h1>
          <img
            src="/assets/svg/ico-hamburger-close.svg"
            class="cross-button pointer-cursor pr-3"
            (click)="closeDialog()"
          />
        </div>
      </ng-container>

      <div class="row d-flex flex-row justify-content-between px-4 ml-3 pb-2">
        <ng-container *ngIf="parentType === CONSTANTS.UNIT">
          <div class="row w-75">
            <div class="col-sm-10">
              <div
                class="device-details d-flex flex-column justify-content-center align-items-left"
              >
                <p class="unit-name">
                  {{ "UNIT" | translate }} {{ selectedUnitName }}
                </p>
                <div class="lock-name">
                  <app-with-tooltip [showHelpCursor]="true">{{
                    formInstance?.deviceName.value
                  }}</app-with-tooltip>
                </div>

                <p class="lock-date mt-1">
                  {{
                    formInstance?.updatedTime.value
                      | parsedDateTime : "MMM d, yyyy h:mma"
                  }}
                </p>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="parentType === CONSTANTS.ACCESSPOINT">
          <div
            class="device-details d-flex flex-column justify-content-center align-items-left col-9"
          >
            <p class="unit-name">
              <app-with-tooltip [showHelpCursor]="true">
                {{ "ACCESSPOINT" | translate
                }}{{ formInstance?.accessPointName.value }}</app-with-tooltip
              >
            </p>
            <span class="lock-name">
              <app-with-tooltip [showHelpCursor]="true">{{
                formInstance?.deviceName.value
              }}</app-with-tooltip>
            </span>
            <p
              class="lock-date"
              *ngIf="
                parentType === CONSTANTS.ACCESSPOINT &&
                (deviceType === CONSTANTS.CONTROLLER ||
                  deviceType === CONSTANTS.COMBO_READER)
              "
            >
              {{
                formInstance?.updatedAt.value
                  | parsedDateTime : "MMM d, yyyy h:mma"
              }}
            </p>
          </div>
        </ng-container>
        <div class="col-sm-2">
          <div class="device-type-image col-3 align-items-right">
            <img
              src="assets/svg/ico-lock-black-and-white.svg"
              class="icon-home-lock"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container lock-detail pr-2 pl-3 mx-3">
      <ng-container
        *ngIf="getBatteryError(activationState, batteryPercentage) !== ''"
      >
        <div class="px-3 py-3 pt-2 pb-2 d-flex floor-installation">
          <div class="pr-3 pl-1 align-self-center">
            <img alt="User Icon" src="assets/svg/ico-alert-red.svg" />
          </div>
          <div class="battery-error">
            {{ getBatteryError(activationState, batteryPercentage) }}
          </div>
        </div>
      </ng-container>
      <form [formGroup]="formGroup" (ngSubmit)="submit()">
        <!-- Lock Name | Device Name-->
        <div
          class="group-container"
          *ngIf="
            deviceType === CONSTANTS.CONTROLLER ||
            deviceType === CONSTANTS.COMBO_READER ||
            parentType === CONSTANTS.UNIT
          "
        >
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance first pointer-cursor"
            >
              <div class="d-flex justify-content-between list-box">
                <div class="title col-5">
                  <img src="assets/svg/ico-lock.svg" class="pr-2" />
                  {{
                    (parentType === CONSTANTS.UNIT
                      ? "LOCK_NAME"
                      : "DEVICE_NAME"
                    ) | translate
                  }}
                </div>
                <div
                  class="selected-value ml-auto text-right col-5"
                  [ngClass]="{
                    'pr-2': parentType === CONSTANTS.ACCESSPOINT
                  }"
                >
                  <span class="text-height">
                    <app-with-tooltip [showHelpCursor]="true">{{
                      formInstance?.deviceName.value
                    }}</app-with-tooltip>
                  </span>
                </div>
                <div
                  class="btn-list"
                  *ngIf="parentType === CONSTANTS.UNIT"
                  (click)="navigateToUpdateDeviceName()"
                >
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="name"
                    class="text-right"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'LOCK_NAME' | translate"
                formControlName="deviceName"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <!-- Lock Name | DOOR_MODE-->
        <div
          class="group-container"
          *ngIf="parentType === CONSTANTS.ACCESSPOINT"
        >
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance first pointer-cursor"
              (click)="navigateToDoorMode()"
            >
              <div class="d-flex justify-content-between list-box">
                <div class="title col-5">
                  <img src="assets/svg/ico-lock.svg" class="pr-2" />
                  {{ "DOOR_MODE" | translate }}
                </div>
                <div
                  class="selected-value ml-auto text-right col-5"
                  [ngClass]="{
                    'pr-2': parentType === CONSTANTS.ACCESSPOINT
                  }"
                >
                  <p>
                    <app-with-tooltip [showHelpCursor]="true">{{
                      deviceStatusResponse[formInstance?.deviceMode.value]
                        | translate
                    }}</app-with-tooltip>
                  </p>
                </div>
                <div class="btn-list">
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="name"
                    class="text-right"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'DOOR_MODE' | translate"
                formControlName="deviceMode"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <!-- Lock Name | DOOR State-->
        <div
          class="group-container"
          *ngIf="parentType === CONSTANTS.ACCESSPOINT"
        >
          <div class="form-group rounded-top form-container">
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance last pointer-cursor"
            >
              <div class="d-flex justify-content-between list-box">
                <div class="title col-5">
                  <img src="assets/svg/ico-lock.svg" class="pr-2" />
                  {{ "DOOR_STATE" | translate }}
                </div>
                <div
                  class="selected-value ml-auto text-right col-5"
                  [ngClass]="{
                    'pr-2': parentType === CONSTANTS.ACCESSPOINT
                  }"
                >
                  <p>
                    <app-with-tooltip [showHelpCursor]="true">{{
                      formInstance?.deviceOpenedState.value
                        | translate
                        | titlecase
                    }}</app-with-tooltip>
                  </p>
                </div>
                <!-- <div class="btn-list">
                  <button
                    mat-icon-button
                    type="button"
                    aria-label="name"
                    class="text-right"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div> -->
              </div>
              <input
                matInput
                [placeholder]="'DOOR_MODE' | translate"
                formControlName="deviceOpenedState"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <!-- Lock Sound -->

        <ng-container *ngIf="parentType === CONSTANTS.UNIT">
          <div class="group-container">
            <div
              class="form-group row form-container slide-toggle-primary middle"
            >
              <div class="col-8 pt-2">
                <mat-label class="title col-5">{{
                  "LOCK_SOUND" | translate
                }}</mat-label>
              </div>
              <div
                class="selected-value ml-auto text-right col-3"
                [ngClass]="{
                  'pr-2': parentType === CONSTANTS.ACCESSPOINT
                }"
              >
                <p class="pt-2 locksoud-text-weight pr-2">
                  <app-with-tooltip [showHelpCursor]="true">{{
                    (formInstance?.lockSound?.value === "true"
                      ? "Enabled"
                      : "Disabled"
                    ) | translate
                  }}</app-with-tooltip>
                </p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Auto Lock  -->
        <!-- Auto lock Time -->
        <ng-container *ngIf="parentType === CONSTANTS.UNIT">
          <div class="group-container">
            <div class="form-group rounded-top form-container">
              <mat-form-field
                appearance="fill"
                class="w-100 list-container primary-input bottom-zero padding-top-balance middle"
              >
                <div class="d-flex justify-content-between list-box">
                  <mat-label class="title col-9">{{
                    "OPERATION_WINDOW" | translate
                  }}</mat-label>
                  <div class="selected-value ml-auto text-right pr-2 col-3">
                    <p>
                      <ng-container *ngIf="formInstance?.autoLockTime?.value">
                        <app-with-tooltip [showHelpCursor]="true">
                          {{ formInstance?.autoLockTime?.value }}
                          {{ "TIME_IN_SECONDS" | translate }}
                        </app-with-tooltip>
                      </ng-container>
                    </p>
                  </div>
                </div>
                <input
                  matInput
                  [placeholder]="'AUTO_LOCK' | translate"
                  formControlName="autoLock"
                  class="d-none"
                />
              </mat-form-field>
            </div>
          </div>
        </ng-container>

        <ng-container
          *ngIf="
            parentType === CONSTANTS.ACCESSPOINT &&
            (deviceType === CONSTANTS.CONTROLLER ||
              deviceType === CONSTANTS.COMBO_READER)
          "
        >
          <!--Device Type-->
          <div class="group-container">
            <div class="form-group rounded-top form-container">
              <mat-form-field
                appearance="fill"
                class="w-100 list-container primary-input bottom-zero padding-top-balance middle pointer-cursor"
              >
                <div class="d-flex justify-content-between list-box">
                  <div class="title col-5">
                    <img
                      src="assets/svg/ico-construct-outline.svg"
                      class="pr-2"
                    />
                    {{ "DEVICE_TYPE" | translate }}
                  </div>
                  <div class="selected-value ml-auto text-right col-5 pr-2">
                    <p>
                      <app-with-tooltip [showHelpCursor]="true">{{
                        formInstance?.deviceType.value | translate
                      }}</app-with-tooltip>
                    </p>
                  </div>
                  <div class="btn-list"></div>
                </div>
                <input
                  matInput
                  [placeholder]="'DEVICE_TYPE' | translate"
                  formControlName="deviceType"
                  class="d-none"
                />
              </mat-form-field>
            </div>
          </div>
        </ng-container>

        <!-- Users Access -->
        <div
          class="group-container"
          *ngIf="
            deviceType === CONSTANTS.CONTROLLER ||
            deviceType === CONSTANTS.COMBO_READER ||
            parentType === CONSTANTS.UNIT
          "
        >
          <div
            class="form-group rounded-top form-container"
            (click)="navigateToUsers()"
          >
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance pointer-cursor"
              [ngClass]="{
                last: parentType === CONSTANTS.UNIT,
                middle: parentType === CONSTANTS.ACCESSPOINT
              }"
            >
              <div class="d-flex justify-content-between list-box">
                <div class="title col-7">
                  <img
                    src="assets/svg/ico-user-access-lock.svg"
                    class="pr-2"
                  />{{ "USERS_ACCESS" | translate }}
                </div>
                <div class="ml-auto d-flex align-items-center">
                  <span class="selected-value">{{
                    formInstance?.usersAccess?.value
                  }}</span>
                  <div class="btn-list">
                    <button
                      mat-icon-button
                      type="button"
                      aria-label="name"
                      class="text-right"
                    >
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'USERS_ACCESS' | translate"
                formControlName="usersAccess"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <!-- Activities -->
        <ng-container
          *ngIf="
            parentType === CONSTANTS.ACCESSPOINT &&
            (deviceType === CONSTANTS.CONTROLLER ||
              deviceType === CONSTANTS.COMBO_READER)
          "
        >
          <div class="group-container">
            <div class="form-group rounded-top form-container">
              <mat-form-field
                appearance="fill"
                class="w-100 list-container primary-input bottom-zero padding-top-balance last pointer-cursor"
              >
                <div class="d-flex justify-content-between list-box">
                  <div class="title col-5">
                    <img src="assets/svg/ico-history.svg" class="pr-2" />{{
                      "ACTIVITIES" | translate
                    }}
                  </div>
                  <div class="selected-value ml-auto text-right col-5">
                    <p>
                      {{ formInstance?.activities?.value }}
                    </p>
                  </div>
                  <div class="btn-list">
                    <button
                      mat-icon-button
                      type="button"
                      aria-label="name"
                      class="text-right"
                    >
                      <mat-icon>arrow_forward_ios</mat-icon>
                    </button>
                  </div>
                </div>
                <input
                  matInput
                  [placeholder]="'ACTIVITIES' | translate"
                  formControlName="activities"
                  class="d-none"
                />
              </mat-form-field>
            </div>
          </div>
        </ng-container>

        <div
          class="information mt-4 mb-3"
          *ngIf="
            deviceType === CONSTANTS.CONTROLLER ||
            deviceType === CONSTANTS.COMBO_READER ||
            parentType === CONSTANTS.UNIT
          "
        >
          <p>{{ "INFORMATION" | translate }}</p>
        </div>

        <!-- Device Info  -->
        <div class="group-container">
          <div
            class="form-group rounded-top form-container"
            (click)="navigateToDeviceInfo()"
          >
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance first pointer-cursor"
            >
              <div class="d-flex justify-content-between list-box">
                <mat-label class="title col-5">
                  <ng-container
                    *ngIf="
                      parentType === CONSTANTS.ACCESSPOINT &&
                        (deviceType === CONSTANTS.CONTROLLER ||
                          deviceType === CONSTANTS.COMBO_READER);
                      else lockInfoLabel
                    "
                  >
                    {{ "DEVICE_INFO" | translate }}
                  </ng-container>
                  <ng-template #lockInfoLabel>
                    {{ "LOCK_INFO" | translate }}
                  </ng-template>
                </mat-label>
                <div class="btn-list">
                  <button
                    type="button"
                    mat-icon-button
                    aria-label="deviceInfo"
                    class="text-right"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'DEVICE_INFO' | translate"
                formControlName="deviceInfo"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <!-- Help/FAQ  -->
        <div class="group-container">
          <div
            class="form-group rounded-top form-container"
            (click)="helpFaqs()"
          >
            <mat-form-field
              appearance="fill"
              class="w-100 list-container primary-input bottom-zero padding-top-balance pointer-cursor"
              [ngClass]="{
                middle:
                  deviceType === CONSTANTS.CONTROLLER ||
                  deviceType === CONSTANTS.COMBO_READER,
                last:
                  deviceType !== CONSTANTS.CONTROLLER &&
                  deviceType !== CONSTANTS.COMBO_READER
              }"
            >
              <div class="d-flex justify-content-between list-box">
                <mat-label class="title col-5">{{
                  "HELP_FAQ" | translate
                }}</mat-label>
                <div class="btn-list">
                  <button
                    type="button"
                    mat-icon-button
                    aria-label="helpFaq"
                    class="text-right"
                  >
                    <mat-icon>arrow_forward_ios</mat-icon>
                  </button>
                </div>
              </div>
              <input
                matInput
                [placeholder]="'HELP_FAQ' | translate"
                formControlName="helpFaq"
                class="d-none"
              />
            </mat-form-field>
          </div>
        </div>

        <ng-container *ngIf="parentType === CONSTANTS.UNIT">
          <div
            [ngClass]="{
              'not-allowed': activationState === CONSTANTS.PENDING_DEACTIVATION
            }"
          >
            <div
              class="d-flex flex-row justify-content-center align-items-center d-none mt-3 pointer-cursor"
              type="button"
              [ngClass]="{
                disabledButton:
                  activationState === CONSTANTS.PENDING_DEACTIVATION
              }"
              (click)="removeLock()"
            >
              <img src="assets/svg/ico-close-circle-outline.svg" />
              <p class="ml-3 pt-3">
                {{ "REMOVE_LOCK" | translate }}
              </p>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="parentType === CONSTANTS.ACCESSPOINT">
          <ng-container
            *ngIf="
              deviceType === CONSTANTS.CONTROLLER ||
              deviceType === CONSTANTS.COMBO_READER
            "
          >
            <div
              class="d-flex flex-row justify-content-center align-items-center d-none mt-4 pointer-cursor pt-260"
              [ngClass]="{
                'pt-260':
                  (deviceType !== CONSTANTS.CONTROLLER ||
                    deviceType !== CONSTANTS.COMBO_READER) &&
                  deviceType !== CONSTANTS.DOOR,
                'pt-2':
                  deviceType === CONSTANTS.CONTROLLER ||
                  deviceType === CONSTANTS.COMBO_READER,
                'pt-130': deviceType === CONSTANTS.DOOR
              }"
              type="button"
              (click)="removeDevice()"
            >
              <img src="assets/svg/ico-close-circle-outline.svg" />
              <p class="ml-3 pt-2">
                {{ "REMOVE_DEVICE" | translate }}
              </p>
            </div>
          </ng-container>

          <ng-container
            *ngIf="
              parentType === CONSTANTS.ACCESSPOINT &&
              deviceType !== CONSTANTS.CONTROLLER &&
              deviceType !== CONSTANTS.COMBO_READER &&
              deviceType !== CONSTANTS.DOOR &&
              formInstance?.enabled.value
            "
          >
            <div
              class="d-flex flex-row justify-content-center align-items-center d-none mt-4 pointer-cursor pt-260"
              [ngClass]="{
                'pt-260':
                  (deviceType !== CONSTANTS.CONTROLLER ||
                    deviceType !== CONSTANTS.COMBO_READER) &&
                  deviceType !== CONSTANTS.DOOR,
                'pt-2':
                  deviceType === CONSTANTS.CONTROLLER ||
                  deviceType === CONSTANTS.COMBO_READER,
                'pt-130': deviceType === CONSTANTS.DOOR
              }"
              type="button"
            >
              <p class="ml-3 pt-2" (click)="updateEnable(false)">
                {{ "DISABLE_DEVICE" | translate }}
              </p>
            </div>
          </ng-container>
        </ng-container>

        <ng-container
          *ngIf="
            parentType === CONSTANTS.ACCESSPOINT &&
            deviceType !== CONSTANTS.CONTROLLER &&
            deviceType !== CONSTANTS.COMBO_READER &&
            deviceType !== CONSTANTS.DOOR &&
            (!formInstance?.enabled.value || formInstance?.enabled.value === '')
          "
        >
          <div
            class="d-flex flex-row justify-content-center align-items-center d-none mt-4 pointer-cursor pt-260"
            [ngClass]="{
              'pt-260':
                (deviceType !== CONSTANTS.CONTROLLER ||
                  deviceType !== CONSTANTS.COMBO_READER) &&
                deviceType !== CONSTANTS.DOOR,
              'pt-2':
                deviceType === CONSTANTS.CONTROLLER ||
                deviceType === CONSTANTS.COMBO_READER,
              'pt-130': deviceType === CONSTANTS.DOOR
            }"
            type="button"
          >
            <p class="ml-3 pt-2" (click)="updateEnable(true)">
              {{ "ENABLE_DEVICE" | translate }}
            </p>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
</div>
